module.exports = __webpack_public_path__ + "741d5adeae1d6307023d3e5ad88b4cdf.svg";